export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img4-06eca8dcf966de5d692adf3983812d49.png";